import { PageContainer } from '@/components'
import { CreateTask } from './create-task'
const Create = () => (
  <PageContainer>
    <CreateTask />
  </PageContainer>
)

export default Create
